import $ from "jquery";
$(document).ready(function(){
    // Check if there is a component on the page first
    if (document.getElementsByClassName('c-card-pricing-list').length) {
        $('.c-card-pricing-list').each(function() {
            let getChildrenWrapper = $(this).find('.c-card-pricing-list__items');
            let getChildren = getChildrenWrapper.children().length;

            if (getChildren <= 3) {
                getChildrenWrapper.addClass('c-card-pricing-list__items--children-3-under');
            } else if ((getChildren % 3 === 0) && (getChildren < 10)) {
                getChildrenWrapper.addClass('c-card-pricing-list__items--children-3 c-card-pricing-list__items--children-4-over');
            } else if ((getChildren % 4 === 0) && (getChildren < 10)) {
                getChildrenWrapper.addClass('c-card-pricing-list__items--children-4 c-card-pricing-list__items--children-4-over');
            } else if ((getChildren % 5 === 0) && (getChildren < 10)) {
                getChildrenWrapper.addClass('c-card-pricing-list__items--children-5 c-card-pricing-list__items--children-4-over');
            } else {
                getChildrenWrapper.addClass('c-card-pricing-list__items--children-other c-card-pricing-list__items--children-4-over');
            }
        });
    }
});
